<div>
  <div>
    @if (to.label) {
      <legend>{{ to.label || key }}</legend>
    }
    @if (to.description) {
      <p>{{ to.description }}</p>
    }
    @if (showError && formControl.errors) {
      <div class="alert alert-danger" role="alert">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    }
    @for (f of field.fieldGroup; track f) {
      <formly-field [field]="f"></formly-field>
    }
  </div>
</div>
